import React, { useEffect, useState } from 'react';
import { CnCheckbox, CnFormItem, CnOSSUpload } from '@cainiaofe/cn-ui';

import './index.scss';

const AiResumeUpload = (props) => {
  const { handleOssUploadSuccess } = props;
  const [checked, setChecked] = useState(false);

  return (
    <div className="ai-resume-upload-wrap">
      <div>您可以上传简历，系统会智能推荐职务哈～</div>
      <CnOSSUpload
        className="ai-resume-upload"
        shape="dragger"
        description="支持 docx, xls, PDF, rar, zip, PNG, JPG 等类型的文件"
        limit={1}
        showRemove={false}
        openFileDialogOnClick={checked}
        beforeUpload={() => {
          if (!checked) return false;
          return Promise.resolve();
        }}
        requestConfig={{
          url: '/api/tars2/file/upload/getUploadFileScrip',
          formatParam: (params) => {
            const { fileName } = params;
            return {
              ...params,
              fileName: encodeURIComponent(fileName)
            };
          }
        }}
        onChange={(value) => {
          console.log('value===', value);
          if (value?.[0]?.status === 'done') {
            handleOssUploadSuccess(value?.[0]?.key, value?.[0]?.name);
          }
        }}
      />
      <CnFormItem
        errors={!checked && ['请先阅读并同意以上协议']}
        className="ai-resume-upload-form-item"
      >
        <CnCheckbox checked={checked} onChange={(v) => setChecked(v)}>
          我已阅读并同意
          <a href="https://jobs.cainiao.com/recruit-notice" target="_blank">
            隐私协议
          </a>
        </CnCheckbox>
      </CnFormItem>
    </div>
  );
};

export default AiResumeUpload;
